export const featureAccess = {
    institutionsGroupAccess: false,
    translationAccess: {
        show: false,
        withFlag: true
    },
};